import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["className"],
      _excluded2 = ["classes", "isMobile", "iconProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Checkmark, Facesheet, Printer } from '@mummssoftware/icons';
import { actionIconStyle as actionIcons } from '../style/ThemeProvider/commonStyles';
import { ActionIcon } from '../ActionIcon';
import messages from './messages';
const NavHeaderIcon = withStyles(({
  palette,
  props
}) => createStyles({
  actionIcons,
  actionItems: _objectSpread({
    paddingRight: 2,
    '&:not(:last-child) $actionIcons:after': {
      borderRight: `1px solid ${palette.background.header}`,
      content: '" "',
      height: 16,
      position: 'absolute',
      right: -3
    }
  }, props.printRules.hide),
  mobileNavIcon: {
    height: 40
  },
  mobileIcons: {
    width: 40,
    height: 40,
    padding: 0,
    marginTop: 5
  },
  mobileItems: _objectSpread({
    flex: '0 1 auto',
    margin: '0 auto'
  }, props.printRules.hide)
}))(_ref => {
  let {
    classes,
    isMobile,
    iconProps: {
      className: iconClassName
    } = {
      className: ''
    }
  } = _ref,
      iconProps = _objectWithoutProperties(_ref.iconProps, _excluded),
      props = _objectWithoutProperties(_ref, _excluded2);

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: isMobile ? classes.mobileItems : classes.actionItems
  }, /*#__PURE__*/React.createElement(ActionIcon, _extends({}, props, {
    classes: {
      root: isMobile ? classes.mobileIcons : classes.actionIcons
    },
    iconProps: _objectSpread({
      className: isMobile ? `${classes.mobileNavIcon} ${iconClassName || ''}` : iconClassName
    }, iconProps)
  })));
});
export const CloseButton = withStyles({
  closeIcon: {
    height: '15px'
  }
})(injectIntl(({
  showClose,
  closeForm,
  intl: {
    formatMessage
  },
  classes
}) => showClose ? /*#__PURE__*/React.createElement(NavHeaderIcon, {
  title: formatMessage(messages.close),
  id: "NavHeaderIcon",
  Icon: Checkmark,
  onClick: closeForm,
  iconProps: {
    className: classes.closeIcon
  }
}) : null));
/** @component */

export const CardHeaderNav = withStyles(({
  props
}) => createStyles({
  mobileGridStyle: {
    height: `calc(50px + var(--safe-area-inset-bottom))`,
    backgroundColor: 'rgba(0, 0, 0, 0.45)'
  },
  root: props.printRules.hide
}))(injectIntl(({
  classes,
  patient,
  intl: {
    formatMessage
  },
  showClose,
  closeForm,
  printFn,
  faxFn,
  emailFn,
  isMobile
}) => {
  const [printMenuAnchor, setPrintMenuAnchor] = useState(null);
  const hasPrintMenu = typeof printFn === 'function' && (typeof faxFn === 'function' || typeof emailFn === 'function');

  const handlePrintIconClick = e => {
    if (hasPrintMenu) {
      setPrintMenuAnchor(e.currentTarget);
    } else if (typeof printFn === 'function') {
      printFn();
    } else {
      window.print();
    }
  };

  const handlePrintMenuClose = () => setPrintMenuAnchor(null);

  const handlePrint = () => {
    handlePrintMenuClose();
    if (typeof printFn === 'function') printFn();
  };

  const handleFax = () => {
    handlePrintMenuClose();
    if (typeof faxFn === 'function') faxFn();
  };

  const handleEmail = () => {
    handlePrintMenuClose();
    if (typeof emailFn === 'function') emailFn();
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: isMobile ? `${classes.mobileGridStyle} ${classes.root}` : classes.root,
    justifyContent: "center",
    spacing: 0
  }, /*#__PURE__*/React.createElement(NavHeaderIcon, {
    title: formatMessage(messages.facesheet),
    Icon: Facesheet,
    target: "__blank",
    href: `${patient.facesheetURL}?print=off`,
    isMobile: isMobile
  }), /*#__PURE__*/React.createElement(NavHeaderIcon, {
    isMobile: isMobile,
    title: formatMessage(messages.print),
    Icon: Printer,
    onClick: handlePrintIconClick
  }), hasPrintMenu && /*#__PURE__*/React.createElement(Menu, {
    anchorEl: printMenuAnchor,
    open: Boolean(printMenuAnchor),
    onClose: handlePrintMenuClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handlePrint
  }, formatMessage(messages.print)), typeof faxFn === 'function' && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleFax
  }, formatMessage(messages.fax)), typeof emailFn === 'function' && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleEmail
  }, "Email")), /*#__PURE__*/React.createElement(CloseButton, {
    closeForm: closeForm,
    showClose: showClose
  }));
}));
export default CardHeaderNav;